/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [vp.FAQAllQuestionsResponse, () => void, () => void];

function useFetchFAQAllQuestions({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [response, setResponse] = useState<vp.FAQAllQuestionsResponse>({
    ErrorMessage: '',
    Success: false,
    FAQAllQuestions: {},
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  useEffect(() => {
    const sendRequest = async () => {
      const res = await api.fetchFAQAllQuestions(source);
      setResponse(res);
      setSendRequest(false);
      return () => {};
    };
    if (shouldSendRequest) void sendRequest();
    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);
  return [
    response,
    () => {
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setResponse({
        ErrorMessage: '',
        Success: false,
        FAQAllQuestions: {},
      });
    },
  ];
}
export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchFAQAllQuestions);
